/**
 * 浏览器兼容性检查工具
 */

export interface BrowserCheckResult {
  compatible: boolean;
  reason?: string;
  supportedFeatures?: string[];
  unsupportedFeatures?: string[];
}

/**
 * 检查浏览器是否支持 Widget
 */
export function checkBrowserCompatibility(): BrowserCheckResult {
  const requiredAPIs = [
    { name: 'Proxy', path: 'window.Proxy' },
    { name: 'Promise', path: 'window.Promise' },
    { name: 'Fetch', path: 'window.fetch' },
    { name: 'WebSocket', path: 'window.WebSocket' },
    { name: 'Map', path: 'window.Map' },
    { name: 'Set', path: 'window.Set' },
  ];

  const supported: string[] = [];
  const unsupported: string[] = [];

  for (const api of requiredAPIs) {
    const exists = api.path.split('.').reduce((obj: any, key) => obj?.[key], window);
    if (exists) {
      supported.push(api.name);
    } else {
      unsupported.push(api.name);
    }
  }

  // 检查 Shadow DOM
  const hasShadowDOM = typeof HTMLElement.prototype.attachShadow === 'function';
  if (hasShadowDOM) {
    supported.push('ShadowDOM');
  } else {
    unsupported.push('ShadowDOM');
  }

  // 检查 CSS 支持
  const hasCssVariables = CSS.supports('color', 'var(--test)');
  if (hasCssVariables) {
    supported.push('CSS Variables');
  } else {
    unsupported.push('CSS Variables');
  }

  if (unsupported.length > 0) {
    return {
      compatible: false,
      reason: `浏览器不支持以下功能: ${unsupported.join(', ')}`,
      supportedFeatures: supported,
      unsupportedFeatures: unsupported
    };
  }

  return {
    compatible: true,
    supportedFeatures: supported
  };
}

/**
 * 获取浏览器信息
 */
export function getBrowserInfo(): {
  name: string;
  version: string;
  userAgent: string;
} {
  const ua = navigator.userAgent;
  let name = 'Unknown';
  let version = 'Unknown';

  // Chrome
  if (ua.indexOf('Chrome') > -1 && ua.indexOf('Edg') === -1) {
    name = 'Chrome';
    const match = ua.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
    if (match) version = match[1];
  }
  // Edge
  else if (ua.indexOf('Edg') > -1) {
    name = 'Edge';
    const match = ua.match(/Edg\/(\d+\.\d+\.\d+\.\d+)/);
    if (match) version = match[1];
  }
  // Firefox
  else if (ua.indexOf('Firefox') > -1) {
    name = 'Firefox';
    const match = ua.match(/Firefox\/(\d+\.\d+)/);
    if (match) version = match[1];
  }
  // Safari
  else if (ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') === -1) {
    name = 'Safari';
    const match = ua.match(/Version\/(\d+\.\d+\.\d+)/);
    if (match) version = match[1];
  }

  return {
    name,
    version,
    userAgent: ua
  };
}

/**
 * 检查是否在移动设备上
 */
export function isMobile(): boolean {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
}
